import React from 'react'
import Big from 'big.js'
import { useFormContext, useWatch } from 'react-hook-form'
import { Button } from '@mui/material'
import { ROUNDING_PRECISIONS } from 'utils/constants'
import type { InvoicePaymentCreation } from 'components/containers/invoice-payments/types'
import { safeNumber } from 'components/containers/invoice-payments/utils/utils'

interface QuickAddAdjustmentButtonProps {
  onClick: () => void
  selectedInvoices: InvoicePaymentCreation[]
}

export const QuickAddAdjustmentButton: React.FC<QuickAddAdjustmentButtonProps> = ({ onClick, selectedInvoices }) => {
  const { control } = useFormContext()
  const paymentAmount = useWatch({
    control,
    name: 'paymentAmount',
    defaultValue: '',
  })
  const invoicesFormData = useWatch({
    control,
    name: 'invoices',
    defaultValue: {},
  })

  const shouldEnableQuickAddAdjustments = selectedInvoices.some(invoice => {
    const invoiceFormData = invoicesFormData[invoice.id]
    const amountPaid = Big(safeNumber(invoiceFormData.amountPaid || invoice.amountPaid))
    const adjustment = Big(safeNumber(invoiceFormData.adjustment || invoice.adjustment))
    const remainder = Big(safeNumber(invoice.amountDue)).sub(amountPaid).sub(adjustment).round(ROUNDING_PRECISIONS.COST)
    return !remainder.eq(0)
  })

  if (selectedInvoices.length === 0) return null

  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={onClick}
      disabled={!paymentAmount || safeNumber(paymentAmount) <= 0 || !shouldEnableQuickAddAdjustments}
      sx={{
        ml: 2,
      }}
      data-testid="quick-add-adjustments-button"
    >
      Quick Add Adjustments
    </Button>
  )
}

export default QuickAddAdjustmentButton
